<template>
  <div class="border-gray-200 pb-5 sm:flex sm:items-center sm:justify-between">
    <h3 class="text-lg font-medium leading-6 text-gray-900">Plans & Billing</h3>
  </div>
</template>
